import setupStore from 'store'
import App from './App'
import rootReducer from './reducers'
const Store = setupStore({
  rootReducer,
})
export { App, Store }